import { Center, Stack, Loader, Text } from '@mantine/core';

type LoadingScreenProps = {
  message?: string;
};

export const LoadingScreen = ({ message }: LoadingScreenProps) => {
  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <Loader size="lg" color="orange" />
        {message && (
          <Text c="dimmed" size="sm">
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  );
};
